export default __webpack_public_path__ + "static/media/tablefilter.38eeb9b8.svg";